module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-Book.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-Book.woff
 ** module id = 1097
 ** module chunks = 0
 **/